import { TFunction } from "i18next";

export const statusLicensesOptions = (t: TFunction<"global", undefined>) => [
  {
    value: "unassigned",
    label: t("licenses.unassigned"),
    description: "",
    id: "unassigned",
  },
  {
    value: "runningLow",
    label: t("licenses.lowOrEmpty"),
    description: "",
    id: "runningLow",
  },
  {
    value: "expiringSoon",
    label: t("licenses.expSoon"),
    description: "",
    id: "expiringSoon",
  },
];
